export default __webpack_public_path__ + "static/EdinburghOutlaws-81a790333c79f92a67af96beae1941d6.jpg";